import styled from 'styled-components';
import React, { useState, useEffect, useRef } from "react";
import Slide from "../slide.js";
import SNUG_DB_img from "../img/SNUG-DB.png";
import Crow_img_1 from "../img/Crow/5.png";
import Grape from "../img/SNUG_DB_Grape.png";
const Title_span = styled.span`
font-family: "Title";        
    display : inline-block;
    font-size : 35px; 
    font-weight : bold;
    margin-top :70px ;
`
const Content_p = styled.p`
font-family: "Content";        
    margin : 20px 0 ; 
    font-size : 20px; 
    line-height : 40px;
    color : #212121;
`
const Wrapper_div = styled.div`
    margin : 0 10%;
`
const Img = styled.img`
margin : 50px 0 ;
    width : 960px; 
    height : 204.104px;
`
function Introduction(){
    return(
        <Wrapper_div>
            <Title_span>Introduction</Title_span>
            <Content_p>The Seoul National University Genitourinary Cancer Database (SNUG-DB) is a set of prospectively collected, retrospective datasets for surgical cohort of prostate cancer (PC), renal cell carcinoma (RCC), and urothelial cancer (UC). They have larger patients number with longer follow-up duration compared with SUPER-GUC.</Content_p>
            <Img src={Grape}/>
        </Wrapper_div>
    )
}
function SNUG_DB(){
    return (
        <Wrapper>
            <Slide imgURL={SNUG_DB_img} inputText="SNUG DB"/>
            <Introduction/>
            <Crow_img1 src={Crow_img_1}/>
        </Wrapper>
    )
}  
const Wrapper = styled.div`
position : relative; 
top : 90px;
width : 1200px; 
margin : 0 auto; 
font-family: "En";        
margin-bottom : 70px;
`
const Crow_img1 = styled.img`
width : 200px; 
height : 118.57px;
position : absolute;
top:250px;
right :130px;
transform: rotate3d(0, 0, 0.1, 30deg);

`

export default SNUG_DB;